'use client'

import Button from '@dustin-web/microsite-components/src/button'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import Icon from '@dustin-web/microsite-components/src/icon'
import {
  ModalDialog,
  ModalDialogContent,
  ModalDialogFooter,
  ModalDialogHeader,
} from '@dustin-web/microsite-components/src/modal-dialog'
import TextInput, { InputType } from '@dustin-web/microsite-components/src/text-input'
import { DigitalData } from '@dustin-web/microsite-components/src/utils/digital-data'
import { useState } from 'react'
import { registerNotifyme } from '@productsite-beta/src/actions/register-notifyme'

export const NotifyMeBox = ({
  show,
  productErpIdentifier,
}: {
  show: boolean | undefined
  productErpIdentifier: string
}) => {
  const { translate } = useTranslations()
  const [showDialog, setShowDialog] = useState(false)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const [showAlreadySignedUpDialog, setShowAlreadySignedUpDialog] = useState(false)
  const [invalidEmail, setInvalidEmail] = useState(false)
  const [email, setEmail] = useState<string>('')
  const [genericError, setGenericError] = useState<boolean>(false)

  if (!show) {
    return null
  }

  const handleOnConfirm = async () => {
    const [error, data] = await registerNotifyme(email, productErpIdentifier)
    if (error) {
      DigitalData.pushNotifyMeEvent('notify_me_generic_error')
      setGenericError(true)
    }
    if (data?.createNotifyMeRegistration?.errorMessage === 'INVALID_EMAIL') {
      setInvalidEmail(true)
    } else if (data?.createNotifyMeRegistration?.errorMessage === 'REGISTRATION_EXISTS') {
      setShowDialog(false)
      setShowAlreadySignedUpDialog(true)
      DigitalData.pushNotifyMeEvent('monitor_product_already_subcribed')
    } else if (!data?.createNotifyMeRegistration?.errorMessage) {
      setShowAlreadySignedUpDialog(false)
      setShowDialog(false)
      setShowConfirmDialog(true)
      DigitalData.pushNotifyMeEvent('monitor_product_success')
    } else {
      DigitalData.pushNotifyMeEvent('notify_me_generic_error')
      setGenericError(true)
    }

    /*
      public const string ProductNotFound = "PRODUCT_NOT_FOUND";
      public const string RegistrationNotFound = "REGISTRATION_NOT_FOUND";
      public const string RegistrationAlreadyExists = "REGISTRATION_EXISTS";
      public const string InvalidRegistration = "INVALID_REGISTRATION";
      public const string InvalidEmail = "INVALID_EMAIL";
      public const string InvalidUser = "INVALID_USER";
      public const string InvalidProduct = "INVALID_PRODUCT";
      */
  }
  function handleOnShowModalClicked() {
    setShowConfirmDialog(false)
    setInvalidEmail(false)
    setShowAlreadySignedUpDialog(false)
    setShowDialog(true)
    DigitalData.pushNotifyMeEvent('notify_me_open_pop_up')
  }
  return (
    <>
      <div className="c-box t-light-blue align-items-center u-mb-16">
        <div className="d-flex align-items-start u-mb-16">
          <div className="u-pt-4">
            <Icon name="availability" className="i-20 i-light-blue i-multi-layered u-mr-8" />
          </div>
          <p className="u-fs-14" style={{ lineHeight: '130%' }}>
            {translate('NotifyMe_Product_Not_In_Stock')}
          </p>
        </div>
        <div className="u-pl-32">
          <Button
            primary
            className="u-mb-0"
            onClick={handleOnShowModalClicked}
            text={translate('NotifyMe_Stock_Update')}
          />
        </div>
      </div>

      <SignupModal
        showDialog={showDialog}
        invalidEmail={invalidEmail}
        setShowDialog={setShowDialog}
        handleOnConfirm={handleOnConfirm}
        setEmail={setEmail}
        email={email}
        genericError={genericError}
      />

      <SuccessModal
        showDialog={showConfirmDialog}
        setShowDialog={setShowConfirmDialog}
        email={email}
      />
      <AlreadySignedUpModal
        showDialog={showAlreadySignedUpDialog}
        setShowDialog={setShowAlreadySignedUpDialog}
      />
    </>
  )
}

const AlreadySignedUpModal = ({
  showDialog,
  setShowDialog,
}: {
  showDialog: boolean
  setShowDialog: (arg: boolean) => void
}) => {
  const { translate } = useTranslations()
  const handleOnClose = () => {
    setShowDialog(false)
  }
  return (
    <ModalDialog show={showDialog} handleClose={handleOnClose}>
      <ModalDialogHeader>
        <div className="c-dialog__title">
          <h2 id="notify" className="h3 u-mb-8">
            {translate('NotifyMe_Stock_Update_Already_Signed_Up')}
          </h2>
        </div>
        <p className="p-sm">{translate('NotifyMe_Email_Info_Already_Signed_Up')}</p>
      </ModalDialogHeader>
      <ModalDialogFooter>
        <Button
          className="c-btn--block"
          primary
          onClick={handleOnClose}
          text={translate('MobileCloseLabel')}
        />
      </ModalDialogFooter>
    </ModalDialog>
  )
}
const SignupModal = ({
  showDialog,
  setShowDialog,
  handleOnConfirm,
  invalidEmail,
  setEmail,
  email,
  genericError,
}: {
  showDialog: boolean
  setShowDialog: (arg: boolean) => void
  handleOnConfirm: () => void
  invalidEmail: boolean
  setEmail: (arg: string) => void
  email: string
  genericError: boolean
}) => {
  const { translate } = useTranslations()
  const handleOnClose = () => {
    DigitalData.pushNotifyMeEvent('cancel_monitor_product')
    setShowDialog(false)
  }
  return (
    <ModalDialog show={showDialog} handleClose={handleOnClose}>
      <ModalDialogHeader>
        <div className="c-dialog__title">
          <h2 id="notify" className="h3 u-mb-8">
            {translate('NotifyMe_Stock_Update')}
          </h2>
        </div>
        <p className="p-sm">{translate('NotifyMe_Email_Info')}</p>
      </ModalDialogHeader>
      <ModalDialogContent>
        {!genericError ? (
          <>
            <form className="c-form">
              <TextInput
                label={`${translate('NotifyMe_Email_Adresses')}*`}
                placeHolder={translate('NotifyMe_Email_Adresses')}
                type={InputType.EMAIL}
                value={email}
                error={invalidEmail}
                onChange={e => setEmail(e.target.value)}
                inputClassName="u-bg-light-gray"
              />
            </form>
            <p
              className="p-sm"
              dangerouslySetInnerHTML={{ __html: translate('NotifyMe_Legal_Text') }}></p>
          </>
        ) : (
          <p className="c-form__error-text">Something went wrong</p>
        )}
      </ModalDialogContent>
      <ModalDialogFooter
        showCancel
        cancelText={translate('Cancel')}
        showConfirm
        onCancel={handleOnClose}
        confirmText={translate('NotifyMe_Watch_Product')}
        onConfirm={handleOnConfirm}
        className="u-pt-0"
      />
    </ModalDialog>
  )
}

const SuccessModal = ({
  showDialog,
  setShowDialog,
  email,
}: {
  email: string
  showDialog: boolean
  setShowDialog: (arg: boolean) => void
}) => {
  const { translate } = useTranslations()
  return (
    <ModalDialog show={showDialog} handleClose={() => setShowDialog(false)}>
      <ModalDialogHeader>
        <div className="c-dialog__title">
          <h2 id="notify" className="h3 u-mb-8">
            {translate('NotifyMe_Stock_Update_Success')}
          </h2>
        </div>
        <p className="p-sm">{translate('NotifyMe_Email_Info_Success', { email: email })}</p>
      </ModalDialogHeader>
      <ModalDialogFooter>
        <Button
          className="c-btn--block"
          primary
          onClick={() => setShowDialog(false)}
          text={translate('MobileCloseLabel')}
        />
      </ModalDialogFooter>
    </ModalDialog>
  )
}
